import { render, staticRenderFns } from "./headerUploadDocs.vue?vue&type=template&id=2c0818cf&scoped=true"
import script from "./headerUploadDocs.vue?vue&type=script&lang=js"
export * from "./headerUploadDocs.vue?vue&type=script&lang=js"
import style0 from "./headerUploadDocs.vue?vue&type=style&index=0&id=2c0818cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0818cf",
  null
  
)

export default component.exports